<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-back="navback"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
            <h1><v-icon large>mdi-bug-check</v-icon>N°{{ item['id'] }} - {{ item['name'] }}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <v-row>
      <v-col md="3" v-if="item.product">
        <ImageView :item="item.product" filter="250x250" :edit="false" />
      </v-col>
      <v-col md="9">
        <QualityCheckForm
          ref="updateForm"
          v-if="item"
          :values="item"
          :errors="violations"
      />
      </v-col>
    </v-row>
    <v-card >

        <v-app-bar flat >
          <v-icon>mdi-bug-check</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('qualitycheck.qualitycheck.qualitycheckvalues')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </v-app-bar>
      <v-card-text v-if="testValues">
        <v-stepper  v-model="stepState" vertical >
          <template v-for="(testValue, index) in testValues" >
            <v-stepper-step
              :key="testValue['@id'] + '1'"
              :step="index +1"
              :complete="testValue['value'].successValue"
              complete-icon="mdi-check-circle"
              edit-icon="mdi-check-circle"
              error-icon="mdi-close-circle"
              color='green'
              :rules="[() => ( testValue['value'].successValue || testValue['value'].originValue) ]"
              editable
              >
            <span v-if="locale == 'fr' & testValue['qualityCheckTest'].namefr != ''">{{ testValue['qualityCheckTest'].namefr }}</span>
            <span v-else>{{ testValue['qualityCheckTest'].name }}</span>
            </v-stepper-step>
            <v-stepper-content :step="index +1" :key="testValue['@id']+ '2'">
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <QualityCheckTestPanel
                    ref="qualitycheckpanel"
                    v-if="testValue['qualityCheckTest']"
                    :values="testValue['qualityCheckTest']"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <QualityCheckValueFormPanel
                      ref="qualitycheckpanelupdateFormPanel"
                      v-if="testValue"
                      :values="testValue"
                      :nextStep="nextStep"
                    />
                </v-col>
              </v-row>

            </v-stepper-content>
          </template>
      </v-stepper>
      </v-card-text>
    </v-card>


    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import QualityCheckForm from '../../components/qualitycheck/Form.vue';
import QualityCheckValueFormPanel from '../../components/qualitycheckvalue/FormPanel.vue';
import QualityCheckTestPanel from '../../components/qualitychecktest/Panel.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import ListMixin from '../../mixins/ListMixin';
import ImageView from '../../components/ImageView.vue';
import i18n from '../../i18n.js';

const servicePrefix = 'QualityCheck';

export default {
  name: 'QualityCheckUpdate',
  servicePrefix,
  mixins: [UpdateMixin,ListMixin],
  components: {
    Loading,
    Toolbar,
    QualityCheckForm,
    QualityCheckTestPanel,
    QualityCheckValueFormPanel,
    ImageView
  },
  data() {
    return {
      stepState: 0,
      item: {},
    };
  },
  beforeMount() {
      this.getTests({'qualityCheck': this.$route.params.id ,'itemsPerPage': 100,'order[qualityCheckTest]': 'desc'});
  },
  computed: {
    ...mapFields('qualitycheck', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('qualitycheck', ['find']),
    ...mapGetters('qualitycheckvalue', {
      testValues: 'list'
    }),
    ...mapFields('qualitycheckvalue', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    }),
    locale() {
      return i18n.locale;
    },
    /*
    step: {
      get() {
        return this.stepState
      },
       set(value) { this.stepState = value; }
    }
    */
  },
  watch: {
    testValues() {
      console.log(this.testValues);
      /*
      if (this.stepState != 0) {
        var state = null;
        for (var i = 0; i < this.testValues.length; i++) {
          if (this.testValues[i]) {
            if (this.testValues[i].['value'].originValue ) {
              state = this.testValues[i].['qualityCheckTest'].number;
            }
          }

        }
        if (state) {
          this.stepState =state ;
        } else {
          this.stepState =  this.testValues.length;
        }
      }
*/
    },


  },
  methods: {
    ...mapActions('qualitycheck', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    }),
    ...mapActions('qualitycheckvalue', {
      getTests: 'fetchAll',
      deleteItem: 'del'
    }),
    nextStep(number) {
      var n = number;
      if (n === this.steps) {
        this.stepState = 1
      } else {
        this.stepState = n + 1
      }
    },
  }
};
</script>
<style>
.v-stepper__step--active + .v-stepper__content > .v-stepper__wrapper {
  height: auto !important; 
}
</style>
